import styled, { css } from 'styled-components';

export const Root = styled.div`
  width: 100%;
  padding: 12px;
  border-radius: 10px;
  border: 1px solid rgba(155, 89, 182, 0.15);
  background: rgba(255, 255, 255, 0.03);
  font-family: 'Share Tech Mono', monospace;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.45);
`;

export const MainBlock = styled.div`
  display: flex;
  align-items: center;
`;

export const ExpandableBlock = styled.div<{ $isOpen: boolean }>`
  ${({ $isOpen }) =>
    !$isOpen &&
    css`
      display: none;
    `}
`;

export const ArrowDown = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
  transition: 0.15s;
`;

export const ExpandButton = styled.button<{ $isOpen: boolean }>`
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 6px;
  margin: -6px;
  display: flex;
  align-items: center;
  color: inherit;

  &:hover {
    ${ArrowDown} {
      color: rgba(255, 255, 255, 0.8);
    }
  }

  ${({ $isOpen }) =>
    $isOpen &&
    css`
      ${ArrowDown} {
        transform: rotate(180deg);
      }
    `}
`;

const DEFAULT_FONT_SIZE = 14;

const getPriceFontSize = (width: number, symbolsNumber: number) => {
  if (symbolsNumber === 0) return DEFAULT_FONT_SIZE;
  const fontSize = Math.floor((width / symbolsNumber) * 2);
  return Math.min(fontSize, DEFAULT_FONT_SIZE);
};

export const Price = styled.div<{ $width: number; $symbolsNumber: number }>`
  width: 100%;
  display: flex;
  align-items: center;
  font-size: ${({ $width, $symbolsNumber }) =>
    getPriceFontSize($width - 6 - 6 - 14, $symbolsNumber)}px;
`;

export const PriceTokens = styled.span`
  margin-right: 4px;
  font-family: 'Share Tech Mono', monospace;
  color: rgba(255, 255, 255, 0.8);
`;

export const PriceDollars = styled.span`
  margin-right: 4px;
  color: rgba(255, 255, 255, 0.4);
`;

export const PriceFlipButton = styled.button`
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 4px;
  margin: -4px;
  color: rgba(255, 255, 255, 0.5);
  font-size: 12px;
  transition: 0.15s;

  &:hover {
    color: rgba(255, 255, 255, 0.9);
  }
`;

export const Gas = styled.div`
  margin-right: 2px;
  padding-left: 12px;
  display: flex;
  align-items: center;
  gap: 4px;
  color: rgba(255, 255, 255, 0.45);
  white-space: nowrap;
`;

export const Divider = styled.div`
  margin: 8px 0;
  width: 100%;
  height: 1px;
  background: rgba(155, 89, 182, 0.15);
`;

export const Line = styled.div`
  margin: 8px 0;
  display: flex;
  justify-content: space-between;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const Caption = styled.div`
  color: rgba(255, 255, 255, 0.4);
`;

export const Value = styled.div`
  max-width: calc(100% - 130px);
  padding-left: 12px;
  flex-shrink: 0;
  color: rgba(255, 255, 255, 0.8);
  text-align: right;
`;

export const RoutingTokens = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  color: rgba(255, 255, 255, 0.5);
  transition: 0.15s;
`;

export const RoutingToken = styled.div`
  color: rgba(255, 255, 255, 0.8);
`;

export const RoutingIconWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: 4px;
  color: rgba(255, 255, 255, 0.5);
  transition: 0.15s;
`;

export const RoutingButton = styled.button`
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 4px;
  margin: -4px;
  display: flex;
  align-items: center;
  font-family: 'Share Tech Mono', monospace;
  font-size: inherit;

  &:hover {
    ${RoutingTokens} {
      color: rgba(255, 255, 255, 0.8);
    }

    ${RoutingIconWrapper} {
      color: rgba(255, 255, 255, 0.8);
    }
  }
`;
